import { apiGet, apiPost, apiRequest } from "./client";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const inspirationsApi = {
  archive: () => apiGet("/api/inspirations/archive"),
  listForPeriod: (year, month) =>
    apiGet(`/api/inspirations?year=${year}&month=${month}`),
  get: (id) => apiGet(`/api/inspirations/${id}`),
  attachmentDownloadUrl: (fileId) =>
    `${API_BASE}/api/inspirations/files/${fileId}/download`,
};

export const inspirationsAdminApi = {
  create: (title, year, month) =>
    apiPost("/api/admin/inspirations", { title, year, month }),
  update: (id, patch) =>
    apiRequest(`/api/admin/inspirations/${id}`, {
      method: "PATCH",
      body: patch,
    }),
  remove: (id) =>
    apiRequest(`/api/admin/inspirations/${id}`, { method: "DELETE" }),
  reorder: (items) =>
    apiPost("/api/admin/inspirations/reorder", { items }),
  uploadAttachment: async (id, file, displayName = null) => {
    const fd = new FormData();
    fd.append("file", file);
    if (displayName) fd.append("name", displayName);
    const res = await fetch(
      `${API_BASE}/api/admin/inspirations/${id}/attachments`,
      { method: "POST", credentials: "include", body: fd },
    );
    if (!res.ok) throw new Error(`Upload failed (${res.status})`);
    return res.json();
  },
  removeAttachment: (id, attachmentId) =>
    apiRequest(`/api/admin/inspirations/${id}/attachments/${attachmentId}`, {
      method: "DELETE",
    }),
};
